export const GROWTHBOOK_CLIENT_KEY = 'sdk-iZAK23hYs2qNQ8BK';

export const RECENT_VISITED_PRODUCTS_STORAGE_KEY = 'stiq-recently-viewed';
export const CONTINUE_PURCHASE_PRODUCTS_STORAGE_KEY = 'stiq-continue-purchase';

export const MOENGAGE_SDK_VERSION = '2';
export const MOENGAGE_DATACENTER = 'dc_1';